

export const frontMatter = {
	sidebar_position: 30
};
export const contentTitle = 'Opening';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-features-morphology-opening-md-34c.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import OpenDemo from './demos/open.mask.demo.tsx';
export const toc = [{
  "value": "Kinds of images compatible with algorithm",
  "id": "kinds-of-images-compatible-with-algorithm",
  "level": 3
}, {
  "value": "Parameters and default values",
  "id": "parameters-and-default-values",
  "level": 3
}, {
  "value": "Options",
  "id": "options",
  "level": 4
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    br: "br",
    code: "code",
    em: "em",
    h1: "h1",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "opening",
        children: "Opening"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Combines an erosion filter followed by a dilation filter."
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Image.html#open",
        title: "github.io link",
        children: ["🖼️ Image options and parameters of ", _jsx(_components.code, {
          children: "open"
        }), " method"]
      }), _jsx(_components.br, {}), "\n", _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Mask.html#open",
        title: "github.io link",
        children: ["🎭 Mask options and parameters of ", _jsx(_components.code, {
          children: "open"
        }), " method"]
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Opening_(morphology)#:~:text=In%20mathematical%20morphology%2C%20opening%20is,blue%20square%20with%20round%20corners.&text=denote%20erosion%20and%20dilation%2C%20respectively",
        children: "Opening"
      }), " process in morphology involves a dilation of an image, followed by its erosion.\nThis process allows removing small objects and thin lines while preserving the shape and size of larger objects."]
    }), "\n", _jsx(OpenDemo, {}), "\n", _jsx(_components.h3, {
      id: "kinds-of-images-compatible-with-algorithm",
      children: "Kinds of images compatible with algorithm"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Image property"
          }), _jsx(_components.th, {
            children: "What it means"
          }), _jsx(_components.th, {
            children: "Possible values"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "bitDepth"
            })
          }), _jsx(_components.td, {
            children: "number of bits per channel"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[1,8,16]"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "components"
            })
          }), _jsx(_components.td, {
            children: "number of components"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[1]"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "alpha"
            })
          }), _jsx(_components.td, {
            children: "is alpha channel allowed"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "false"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "parameters-and-default-values",
      children: "Parameters and default values"
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsx(_components.p, {
        children: "Parameters and options for Images and Masks are the same."
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "options"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "options",
      children: "Options"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Property"
          }), _jsx(_components.th, {
            children: "Required"
          }), _jsx(_components.th, {
            children: "Default value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/OpenOptions.html#iterations",
              children: _jsx(_components.code, {
                children: "iterations"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "1"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/OpenOptions.html#kernel",
              children: _jsx(_components.code, {
                children: "kernel"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[[1, 1, 1],[1, 1, 1],[1, 1, 1]]"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.admonition, {
      type: "info",
      children: _jsx(_components.p, {
        children: "The method is also available for Masks."
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

